import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { IMAGES, recentBuyers } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(3);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = () => {
      setMinutesAgo(Math.floor(Math.random() * 12) + 1);
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      }, 6000);
    };
    showTimer = window.setTimeout(cycle, 9000);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-47" data-mp="1u70z3l11qm4y">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -24,
      y: 12
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed bottom-24 left-3 right-3 z-40 sm:right-auto sm:bottom-28 sm:left-5 sm:max-w-sm" role="status" aria-live="polite" data-id="element-48" data-mp="1u8lqx2vz7qz4">
          <div className="flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-2.5 shadow-[0_12px_32px_-8px_rgba(11,27,58,0.35)]" data-id="element-49" data-mp="1bdx1xpomdr5l">
            <img src={IMAGES.bundle} alt="" className="h-12 w-12 shrink-0 rounded-xl bg-cream object-contain p-0.5" data-id="element-50" data-mp="1kgg19zt75ln3" />
            <div className="min-w-0 flex-1" data-id="element-51" data-mp="rs0nthpprbdv">
              <p className="truncate text-[13px] font-bold leading-tight text-navy" data-id="element-52" data-mp="rr93x45hb23f">
                {buyer.name} — {buyer.country}
              </p>
              <p className="text-[11.5px] leading-snug text-navy/60" data-id="element-53" data-mp="20218fdiji5ne">
                Compró el Sistema de Decisión Clínica
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[10.5px] font-semibold text-good" data-id="element-54" data-mp="1v1ve1pkvy51m">
                <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-55" data-mp="28t9vhrz59y6k" />
                Hace {minutesAgo} minutos • Compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="shrink-0 rounded-lg p-1.5 text-navy/40 transition-colors hover:bg-cream hover:text-navy" data-id="element-56" data-mp="1h2vqkl93zw71">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-57" data-mp="1q1h2vynzmezd" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}